import { render, staticRenderFns } from "./ProductPageSize.vue?vue&type=template&id=578e8dd8&scoped=true"
import script from "./ProductPageSize.vue?vue&type=script&lang=js"
export * from "./ProductPageSize.vue?vue&type=script&lang=js"
import style0 from "./ProductPageSize.vue?vue&type=style&index=0&id=578e8dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e8dd8",
  null
  
)

export default component.exports